/**
 * Shop by Sound — FAQ accordion
 */
(function () {
  'use strict';

  function bindFaq() {
    document.querySelectorAll('[data-sbs-faq-item]').forEach((item) => {
      if (item.dataset.sbsBound === '1') return;
      item.dataset.sbsBound = '1';

      const trigger = item.querySelector('[data-sbs-faq-trigger]');
      const panel = item.querySelector('[data-sbs-faq-panel]');
      if (!trigger || !panel) return;

      const setOpen = (open) => {
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
      };

      trigger.addEventListener('click', () => {
        setOpen(!item.classList.contains('is-open'));
      });
    });
  }

  function boot() {
    bindFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.addEventListener('resize', () => {
    document.querySelectorAll('.sbs-faq__item.is-open [data-sbs-faq-panel]').forEach((panel) => {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
    });
  });
})();
